import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { FAQ, PRIVACY_POLICY, LEGAL_NOTICE, CGU } from '~/const/faq';
import USE_MARKETPLACE from '~/const/marketplace';

const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'Mentions',
  components: {
    MdmModal
  },

  data() {
    return {
      showModal: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    getDate() {
      const d = new Date();
      return d.getFullYear();
    },

    setLocale() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },

    helpAndFaqsLinks() {
      return FAQ.find(faq => faq.language === this.locale.iso).url;
    },

    legalNoticeLinks() {
      return LEGAL_NOTICE.find(legalNotice => legalNotice.language === this.locale.iso).url;
    },

    privacyPolicyLinks() {
      return PRIVACY_POLICY.find(privacyPolicy => privacyPolicy.language === this.locale.iso).url;
    },

    cguLinks() {
      return CGU.find(cgu => cgu.language === this.locale.iso).links;
    },

    isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    }

  })
};